var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-right pb-2"},[_c('router-link',{staticClass:"text-black",attrs:{"to":`/smart-menu?uid=${_vm.uid}`}},[_c('span',{staticStyle:{"padding":"10px"}},[_c('CIcon',{attrs:{"name":"cil-x","size":"lg"}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }